import { mockOnePassSubscription } from "./mockOnePassSubscription";
import { ITEM_ID_THAT_WILL_THROW_ERROR } from "@cart-app/mocks/constants";
import {
  Cart,
  CartCoupon,
  CartCouponMetadata,
  CartNotice,
  CartOrderSummary,
  CartParcel,
  CartParcelItem,
  CartShippingLocation,
  OrderSummaryDonation,
} from "@cart-app/generated/graphql";

export const mockCartParcelItems: CartParcelItem[] = [
  {
    __typename: "CartParcelItem" as const,
    id: "1a8abeec-b5e6-47c7-a8f7-abbc233b4e27",
    metadata: {
      eventId: 0,
      sourceId: "foo",
      sourcePosition: 0,
      sourceType: 0,
      sourcePlatform: "MOBILE",
    },
    clubAutoExpressShipping: true,
    personalisedValues: [],
    freeShipping: false,
    offer: {
      seller: {
        id: "1",
        name: "Catch",
      },
      catchPromotion: true,
      currency: "AUD",
      clubFreeShipping: true,
      clubExclusive: false,
      freeShipping: false,
      id: "105057",
      badges: [],
      paymentMethods: [],
      salesChannel: {
        id: "1",
      },
      clubSellPrice: {
        amount: 692,
        currency: "AUD",
      },
      stockLevel: "HIGH",
      clickAndCollect: true,
      originPrice: {
        amount: 699,
        currency: "AUD",
      },
      sellPrice: {
        amount: 699,
        currency: "AUD",
      },
      purchasableQuantity: 10,
      variant: {
        inWishlist: false,
        wishlist: {
          inWishlist: false,
        },
        id: "736221",
        sellable: true,
        offers: [],
        product: {
          id: "241469",
          slug: "3-x-palmolive-naturals-replenishing-soap-bars-milk-honey-90g-4pk-241469",
          sellable: true,
          title:
            "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
          visible: true,
          variants: [],
          personalisedFields: [],
          assets: {
            hero: {
              id: "967353",
              url: "https://static.devcat.ch/images/product/0000/0967/551a3125ef298396884344.jpg",
              altText:
                "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
              height: 540,
              width: 427,
            },
            gallery: [
              {
                id: "967353",
                url: "https://static.devcat.ch/images/product/0000/0967/551a3125ef298396884344.jpg",
                altText:
                  "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
              },
            ],
            sizeCharts: [],
          },
          ratingsSummary: {
            id: "1111",
            numberOfRatings: 1000,
            averageRating: 4.5,
            breakdown: [],
          },
          options: [],
          fromPriceLabel: true,
          sensitive: false,
          adult: false,
          ageRestricted: false,
        },
        variantOptionValues: [
          {
            id: "465468",
            name: "Large",
            option: {
              id: "1123232",
              name: "Size",
              values: [],
            },
          },
        ],
      },
    },
    uri: "/product/3-x-palmolive-naturals-replenishing-soap-bars-milk-honey-90g-4pk-241469/?offer_id=105057",
    quantity: 2,
    totalPrice: {
      amount: 1384,
      currency: "AUD",
    },
    addedByCoupon: false,
    title: "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
    notices: [
      {
        __typename: "CartNotice" as const,
        type: "WARNING",
        message: {
          template: null,
          placeholders: null,
          default:
            "This item is not available in the quantity selected. Quantity has been adjusted from 5 to 2",
        },
        advisory: true,
      },
    ],
  },
  {
    __typename: "CartParcelItem" as const,
    id: "4cf5c2a1-e7f3-4453-8e1e-a7540f8ab474",
    metadata: {
      eventId: 0,
      sourceId: "foo",
      sourcePosition: 0,
      sourceType: 0,
      sourcePlatform: "DESKTOP",
    },
    clubAutoExpressShipping: true,
    personalisedValues: [],
    freeShipping: false,
    offer: {
      catchPromotion: true,
      clubFreeShipping: true,
      clubExclusive: false,
      freeShipping: false,
      badges: [],
      paymentMethods: [],
      seller: {
        id: "1",
        name: "Catch",
      },
      currency: "AUD",
      id: "128720",
      salesChannel: {
        id: "1",
      },
      originPrice: {
        amount: 6999,
        currency: "AUD",
      },
      sellPrice: {
        amount: 6999,
        currency: "AUD",
      },
      clubSellPrice: {
        amount: 692,
        currency: "AUD",
      },
      stockLevel: "HIGH",
      clickAndCollect: true,
      purchasableQuantity: 5,
      variant: {
        inWishlist: true,
        wishlist: {
          inWishlist: true,
        },
        id: "818644",
        sellable: true,
        offers: [],
        variantOptionValues: [],
        product: {
          id: "280972",
          slug: "converse-chuck-taylor-all-star-hi-black-280972",
          sellable: true,
          title: "Converse Chuck Taylor All Star Hi - Black",
          visible: true,
          variants: [],
          personalisedFields: [],
          assets: {
            hero: {
              id: "1192777",
              url: "https://static.devcat.ch/images/product/0001/1192/54c06c713cdff103451550.jpg",
              altText: "Converse Chuck Taylor All Star Hi - Black",
              height: 1080,
              width: 1320,
            },
            gallery: [
              {
                id: "1192777",
                url: "https://static.devcat.ch/images/product/0001/1192/54c06c713cdff103451550.jpg",
                altText: "Converse Chuck Taylor All Star Hi - Black",
              },
            ],
            sizeCharts: [
              {
                id: "1192792",
                url: "https://static.devcat.ch/images/product/0001/1192/53b5e0aea09b8543242681.jpg",
                altText: "Converse Chuck Taylor All Star Hi - Black",
                height: 773,
                width: 427,
              },
            ],
          },
          ratingsSummary: {
            id: "1111",
            numberOfRatings: 3210,
            averageRating: 3.8,
            breakdown: [],
          },
          options: [
            {
              id: "22546",
              name: "US Size",
              values: [
                {
                  name: "US Mens 4",
                  id: "210789",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 4.5",
                  id: "211881",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 6",
                  id: "122210",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 7",
                  id: "122214",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 8",
                  id: "122218",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 9",
                  id: "122222",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 9.5",
                  id: "122430",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 10",
                  id: "122226",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 11",
                  id: "122230",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
                {
                  name: "US Mens 12",
                  id: "122426",
                  option: {
                    id: "",
                    name: "",
                    values: [],
                  },
                },
              ],
            },
          ],
          fromPriceLabel: true,
          sensitive: false,
          adult: false,
          ageRestricted: false,
        },
      },
    },
    uri: "/product/converse-chuck-taylor-all-star-hi-black-280972/?offer_id=128720",
    quantity: 1,
    totalPrice: {
      amount: 6929,
      currency: "AUD",
    },
    addedByCoupon: false,
    title: "Converse Chuck Taylor All Star Hi - Black",
    notices: [
      {
        __typename: "CartNotice" as const,
        type: "ERROR",
        message: {
          template: null,
          placeholders: null,
          default: "Sorry, this item has sold out.",
        },
        advisory: true,
      },
      {
        __typename: "CartNotice" as const,
        type: "ERROR",
        message: {
          template: null,
          placeholders: null,
          default: "Sorry, this item is no longer available.",
        },
        advisory: true,
      },
    ],
  },
  {
    __typename: "CartParcelItem" as const,
    id: "266221f4-2b16-42e3-bb86-c370bed4e5de",
    metadata: {
      eventId: 0,
      sourceId: "foo",
      sourcePosition: 0,
      sourceType: 0,
      sourcePlatform: "DESKTOP",
    },
    clubAutoExpressShipping: true,
    personalisedValues: [
      {
        label: "Amount",
        value: "100",
      },
      {
        label: "Receiver's First Name",
        value: "John",
      },
      {
        label: "Receiver's Last Name",
        value: "Doe",
      },
      {
        label: "Receiver's Email",
        value: "john.doe@gmail.com",
      },
      {
        label: "Message",
        value: "Some message",
      },
    ],
    freeShipping: true,
    offer: {
      catchPromotion: true,
      clubFreeShipping: false,
      clubExclusive: false,
      freeShipping: true,
      currency: "AUD",
      badges: [],
      paymentMethods: [],
      seller: {
        id: "1",
        name: "Catch",
      },
      id: "378363",
      salesChannel: {
        id: "1",
      },
      originPrice: {
        amount: 1,
        currency: "AUD",
      },
      sellPrice: {
        amount: 1,
        currency: "AUD",
      },
      clubSellPrice: {
        amount: 1,
        currency: "AUD",
      },
      stockLevel: "HIGH",
      clickAndCollect: true,
      purchasableQuantity: 0,
      variant: {
        inWishlist: false,
        wishlist: {
          inWishlist: false,
        },
        id: "1070632",
        sellable: true,
        offers: [],
        variantOptionValues: [],
        product: {
          id: "2",
          slug: "catch-of-the-day-gift-card-2",
          sellable: true,
          title: "Catch of the Day Gift Card",
          visible: true,
          variants: [],
          personalisedFields: [],
          ratingsSummary: {
            id: "1111",
            numberOfRatings: 800,
            averageRating: 4.2,
            breakdown: [],
          },
          assets: {
            hero: {
              id: "1905470",
              url: "https://static.devcat.ch/images/product/0001/1914/592b86d71cf00473493336.jpg",
              altText: "Catch of the Day Gift Card",
              height: 1130,
              width: 1500,
            },
            gallery: [
              {
                id: "1905470",
                url: "https://static.devcat.ch/images/product/0001/1914/592b86d71cf00473493336.jpg",
                altText: "Catch of the Day Gift Card",
              },
            ],
            sizeCharts: [],
          },
          options: [],
          fromPriceLabel: true,
          sensitive: false,
          adult: false,
          ageRestricted: false,
        },
      },
    },
    uri: "/product/catch-of-the-day-gift-card-2/?offer_id=378363",
    quantity: 1,
    totalPrice: {
      amount: 10000,
      currency: "AUD",
    },
    addedByCoupon: false,
    title: "Catch of the Day Gift Card",
    notices: [],
  },
];

export const mockCartMarketplaceParcelItems: CartParcelItem[] = [
  {
    __typename: "CartParcelItem" as const,
    id: ITEM_ID_THAT_WILL_THROW_ERROR,
    metadata: {
      eventId: 0,
      sourceId: "foo",
      sourcePosition: 0,
      sourceType: 0,
      sourcePlatform: "DESKTOP",
    },
    clubAutoExpressShipping: true,
    personalisedValues: [],
    freeShipping: false,
    offer: {
      seller: {
        id: "121",
        name: "Urvashi Pandey MarketPlace",
      },
      catchPromotion: true,
      currency: "AUD",
      clubFreeShipping: false,
      clubExclusive: false,
      freeShipping: false,
      badges: [],
      paymentMethods: [],
      id: "6339129",
      salesChannel: {
        id: "1",
      },
      clubSellPrice: {
        amount: 2969,
        currency: "AUD",
      },
      stockLevel: "MEDIUM",
      clickAndCollect: false,
      originPrice: {
        amount: 2999,
        currency: "AUD",
      },
      sellPrice: {
        amount: 2999,
        currency: "AUD",
      },
      purchasableQuantity: 20,
      variant: {
        variantOptionValues: [],
        inWishlist: false,
        wishlist: {
          inWishlist: false,
        },
        id: "1021419",
        sellable: true,
        offers: [],
        product: {
          id: "371339",
          slug: "lamaze-yo-ho-horace-bathtime-story-set-371339",
          sellable: true,
          title: "Lamaze Yo Ho Horace Bathtime Story Set",
          visible: true,
          variants: [],
          personalisedFields: [],
          ratingsSummary: {
            id: "1111",
            numberOfRatings: 1500,
            averageRating: 4.4,
            breakdown: [],
          },
          assets: {
            hero: {
              id: "1781003",
              url: "https://static.devcat.ch/images/product/0001/1780/5670d7c13117d388866717.jpg",
              altText: "Lamaze Yo Ho Horace Bathtime Story Set",
              height: 1080,
              width: 1320,
            },
            gallery: [
              {
                id: "1781003",
                url: "https://static.devcat.ch/images/product/0001/1780/5670d7c13117d388866717.jpg",
                altText: "Lamaze Yo Ho Horace Bathtime Story Set",
              },
            ],
            sizeCharts: [],
          },
          options: [],
          fromPriceLabel: true,
          sensitive: false,
          adult: false,
          ageRestricted: false,
        },
      },
    },
    uri: "/product/lamaze-yo-ho-horace-bathtime-story-set-371339/?offer_id=6339129",
    quantity: 1,
    totalPrice: {
      amount: 2969,
      currency: "AUD",
    },
    addedByCoupon: false,
    title: "Lamaze Yo Ho Horace Bathtime Story Set",
    notices: [],
  },
];

export const mockCartParcel: CartParcel[] = [
  {
    __typename: "CartParcel" as const,
    clubDiscountPrice: {
      amount: 123,
      currency: "AUD",
    },
    clubDiscountMessage: "hey",
    clubUpsellEligible: true,
    id: "in-stock-TRUG",
    sellerName: "Catch",
    marketplaceSeller: false,
    items: mockCartParcelItems,
    dispatchNotice: {
      message: "Leaves warehouse in 1 - 2 business days",
      type: "IN_STOCK",
    },
    selectedShippingOption: {
      id: "StandardShipping",
      locationType: "NORMAL",
      title: "FREE Delivery with OnePass",
      price: {
        amount: 0,
        currency: "AUD",
      },
      attentionTag: "",
      type: "STANDARD",
      clubFreeShipping: true,
    },
    shippingOptions: [
      {
        id: "StandardShipping",
        locationType: "NORMAL",
        title: "FREE Delivery with OnePass",
        price: {
          amount: 0,
          currency: "AUD",
        },
        attentionTag: "",
        type: "STANDARD",
        clubFreeShipping: true,
      },
      {
        id: "ExpressShipping",
        locationType: "NORMAL",
        title: "Express Post",
        price: {
          amount: 200,
          currency: "AUD",
        },
        attentionTag: "",
        type: "EXPRESS",
        clubFreeShipping: false,
      },
      {
        id: "ClickAndCollect",
        locationType: "CLICK_AND_COLLECT",
        title: "FREE Pick Up from ",
        price: {
          amount: 0,
          currency: "AUD",
        },
        attentionTag: "",
        type: "PICKUP",
        clubFreeShipping: true,
      },
    ],
    subtotalPrice: {
      amount: 8313,
      currency: "AUD",
    },
  },
  {
    __typename: "CartParcel" as const,
    id: "marketplace-121",
    clubDiscountPrice: {
      amount: 123,
      currency: "AUD",
    },
    clubDiscountMessage: "hey",
    clubUpsellEligible: false,
    sellerName: "Urvashi Pandey MarketPlace",
    marketplaceSeller: true,
    items: mockCartMarketplaceParcelItems,
    dispatchNotice: {
      message: "Leaves warehouse in 7 business days",
      type: "BULKY_IN_STOCK",
    },
    selectedShippingOption: {
      id: "StandardShipping",
      locationType: "NORMAL",
      title: "Standard Shipping",
      price: {
        amount: 0,
        currency: "AUD",
      },
      attentionTag: "",
      type: "STANDARD",
      clubFreeShipping: true,
    },
    shippingOptions: [
      {
        id: "StandardShipping",
        locationType: "NORMAL",
        title: "Standard Shipping",
        price: {
          amount: 0,
          currency: "AUD",
        },
        attentionTag: "",
        type: "STANDARD",
        clubFreeShipping: true,
      },
    ],
    subtotalPrice: {
      amount: 2969,
      currency: "AUD",
    },
  },
];

export const donationMock: OrderSummaryDonation = {
  __typename: "OrderSummaryDonation" as const,
  organisationName: "the Smith Family",
  total: {
    amount: 90,
    currency: "AUD",
  },
  image: {
    id: "DonationImageID",
    url: "https://s.catch.com.au/assets/0000/0946/5fbeeff8459a0823860790.jpg",
    altText: "The Smith family",
    height: 250,
    width: 200,
  },
  body: "The Smith Family is Australia's leading children's educational-support charity. We help young Australians in need to break the cycle of poverty by supporting their education. By rounding up your purchase today, you'll help these young people to succeed at school, so they can create better futures for themselves.",
  header: "Round up for The Smith Family",
  orderTotalBefore: {
    amount: 16910,
    currency: "AUD",
  },
  orderTotalAfter: {
    amount: 17000,
    currency: "AUD",
  },
  selected: true,
};

export const mockCartOrderSummary: CartOrderSummary = {
  __typename: "CartOrderSummary" as const,
  id: "c364576b-d2bd-4h73-364r-96ec580a123f",
  discounts: [
    {
      discount: {
        amount: 500,
        currency: "AUD",
      },
      label: "1234",
      deletable: true,
      type: "MANUAL",
    },
    {
      discount: {
        amount: 495,
        currency: "AUD",
      },
      label: "$5 off for orders over $100",
      deletable: false,
      type: "AUTOMATIC",
    },
    {
      discount: {
        amount: 995,
        currency: "AUD",
      },
      label: "Free delivery with OnePass",
      deletable: false,
      type: "AUTOMATIC",
    },
  ],
  delivery: {
    deliveryType: "STANDARD",
    total: {
      amount: 0,
      currency: "AUD",
    },
  },
  donation: donationMock,
  giftCards: [
    {
      code: "502904200000456101",
      appliedBalance: {
        amount: 1000,
        currency: "AUD",
      },
      remainingBalance: {
        amount: 5000,
        currency: "AUD",
      },
    },
  ],
  itemSummary: {
    items: [...mockCartParcelItems, ...mockCartMarketplaceParcelItems],
    total: {
      amount: 19900,
      currency: "AUD",
    },
  },
  storeCredit: {
    applied: {
      amount: 0,
      currency: "AUD",
    },
    remaining: {
      amount: 0,
      currency: "AUD",
    },
  },
  ageConfirmationRequired: false,
  subtotalPrice: {
    __typename: "Money" as const,
    amount: 19900,
    currency: "AUD",
  },
  totalPrice: {
    __typename: "Money" as const,
    amount: 18400,
    currency: "AUD",
  },
  totalSaving: {
    __typename: "Money" as const,
    amount: 1000,
    currency: "AUD",
  },
};

export const mockNotices: CartNotice[] = [
  {
    __typename: "CartNotice" as const,
    message: {
      template:
        "There are items in your cart that may incur additional {{ intl_shipping_link }}.",
      placeholders: [
        {
          id: "intl_shipping_link",
          text: "International Seller & Import charges",
          url: "http://catch.com.au/international-seller",
        },
      ],
      default: "Something went wrong",
    },
    type: "ERROR",
    advisory: true,
  },
  {
    __typename: "CartNotice" as const,
    message: {
      template: null,
      placeholders: null,
      default:
        "Sorry, to use this coupon code: Order amount must be greater than $50.",
    },
    type: "ERROR",
    advisory: true,
  },
  {
    __typename: "CartNotice" as const,
    message: {
      template: null,
      placeholders: null,
      default:
        "There are issues with some items in your cart. Please review your order.",
    },
    type: "WARNING",
    advisory: false,
  },
  {
    __typename: "CartNotice" as const,
    message: {
      template: null,
      placeholders: null,
      default: "This is a informative cart notice eg; WFH note.",
    },
    type: "INFO",
    advisory: false,
  },
];

export const mockCouponMetadata: CartCouponMetadata = {
  __typename: "CartCouponMetadata" as const,
  code: "TESTME1",
};

export const mockUserCoupon: CartCoupon = {
  __typename: "CartCoupon" as const,
  coupon: mockCouponMetadata,
  notices: [],
};

export const mockRecommendationParcelItem: CartParcelItem = {
  __typename: "CartParcelItem" as const,
  id: "retrt44-b5e6-47c7-a8f7-fegrt656fgtege3yy3",
  metadata: {
    eventId: 0,
    sourceId: "bar",
    sourcePosition: 0,
    sourceType: 0,
    sourcePlatform: "DESKTOP",
  },
  clubAutoExpressShipping: true,
  personalisedValues: [],
  freeShipping: false,
  offer: {
    catchPromotion: true,
    clubFreeShipping: true,
    clubExclusive: false,
    freeShipping: false,
    badges: [],
    paymentMethods: [],
    seller: {
      id: "1",
      name: "Catch",
    },
    currency: "AUD",
    id: "205057",
    salesChannel: {
      id: "1",
    },
    originPrice: {
      amount: 899,
      currency: "AUD",
    },
    sellPrice: {
      amount: 899,
      currency: "AUD",
    },
    clubSellPrice: {
      amount: 699,
      currency: "AUD",
    },
    stockLevel: "HIGH",
    clickAndCollect: true,
    purchasableQuantity: 8,
    variant: {
      inWishlist: false,
      wishlist: {
        inWishlist: false,
      },
      id: "836221",
      sellable: true,
      offers: [],
      variantOptionValues: [],
      product: {
        id: "241490",
        slug: "48-x-cadbury-caramello-egg-39g-42282",
        sellable: true,
        title: "48 x Cadbury Caramello Egg 39g",
        visible: true,
        variants: [],
        personalisedFields: [],
        assets: {
          hero: {
            id: "967353",
            url: "https://static.devcat.ch/images/product/0000/0301/54fe7649d05ab977273390.jpg",
            altText: "48 x Cadbury Caramello Egg 39g",
            height: 540,
            width: 427,
          },
          gallery: [
            {
              id: "967353",
              url: "https://static.devcat.ch/images/product/0000/0301/54fe7649d05ab977273390.jpg",
              altText: "48 x Cadbury Caramello Egg 39g",
            },
          ],
          sizeCharts: [],
        },
        ratingsSummary: {
          id: "1111",
          numberOfRatings: 800,
          averageRating: 4.2,
          breakdown: [],
        },
        options: [],
        fromPriceLabel: true,
        sensitive: false,
        adult: false,
        ageRestricted: false,
      },
    },
  },
  uri: "/product/48-x-cadbury-caramello-egg-39g-42282",
  quantity: 1,
  totalPrice: {
    amount: 899,
    currency: "AUD",
  },
  addedByCoupon: false,
  title: "48 x Cadbury Caramello Egg 39g",
  notices: [],
};

const mockShippingLocation: CartShippingLocation = {
  city: "MELBOURNE",
  postcode: "3000",
};

export const mockCart: Omit<Cart, "shippingOptions" | "legacyOrderSummary"> = {
  __typename: "Cart" as const,
  id: "c364576b-d2bd-4h73-364r-96ec580a123f",
  clubSubscription: mockOnePassSubscription,
  itemsQuantitySum: 4,
  orderSummary: mockCartOrderSummary,
  parcels: mockCartParcel,
  shippingLocation: mockShippingLocation,
  notices: mockNotices,
  userCoupon: mockUserCoupon,
  canProceedToCheckout: true,
  giftCardSupported: true,
  fingerprint: "1234",
  showOnePassRecommender: false,
};

export default mockCart;
